var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.configButton.class,on:{"click":function($event){return _vm.funcionBtn()}}},[_vm._v(" "+_vm._s(_vm.configButton.text)+" "),_c('div',{staticClass:"point"})])
}
var staticRenderFns = []

export { render, staticRenderFns }